import React from 'react';
import 'assets/app.scss';
import { BrowserRouter } from 'react-router-dom';
import AppRoutes from './AppRoutes';
import AppFooter from './AppFooter';
import AppHeader from './AppHeader';
import { Container, MantineProvider } from '@mantine/core';
import '@mantine/core/styles.css';
import MainMenu from './MainMenu';
import { SettingsProvider } from 'contexts/SettingsContext';
import { AuthProvider } from 'contexts/AuthContext';
import { TammilanitTheme } from './themes/TammilanitTheme';

const App: React.FC = () => (
    <MantineProvider theme={TammilanitTheme}>
        <SettingsProvider>
            <BrowserRouter>
                <AuthProvider>
                    <AppHeader />
                    <Container>
                    <MainMenu />
                        <div className="app">
                            <AppRoutes />
                        </div>
                    </Container>
                    <div className="spacer"></div>
                    <AppFooter />
                </AuthProvider>
            </BrowserRouter>
        </SettingsProvider>
    </MantineProvider>
);

export default App;
